import { MasterDataTable } from "@/features/master-data/components/MasterDataTable";
import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";

type TMasterDataListProps = {};

export const MasterDataListPage: FC<TMasterDataListProps> = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box mb={"40px"}>
        <Typography variant="head24Bold">マスターデータ管理</Typography>
      </Box>
      <MasterDataTable />
    </Stack>
  );
};
